<template>
  <div>
    <section id="doctors" class="doctors">
      <div class="container">
        <div class="section-title" style="margin-top: 7%;">
          <h2>Doctors</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint
            consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat
            sit
            in iste officiis commodi quidem hic quas.</p>
        </div>

        <div class="row">
          <div class="col-7">
            <p class="col-description">You Can sort the doctors list according to your needs.</p>
          </div>
          <div class="col-2">
            <div>
              <b-dropdown text="Doctor Category" block variant="outline-success" class="m-2" menu-class="w-100">
                <b-dropdown-item href="#" class="dropdownitem">Action</b-dropdown-item>
                <b-dropdown-item href="#" class="dropdownitem">Another action</b-dropdown-item>
                <b-dropdown-item href="#" class="dropdownitem">Something else </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-2">
            <div>
              <b-dropdown text="Sort Doctors list by" block variant="outline-success" class="m-2" menu-class="w-100">
                <b-dropdown-item href="#" class="dropdownitem">Action</b-dropdown-item>
                <b-dropdown-item href="#" class="dropdownitem">Another action</b-dropdown-item>
                <b-dropdown-item href="#" class="dropdownitem">Something else</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-lg-6 mt-4" v-for="(doctor, index) in activeDoctor" :key="index">
            <div class="member d-flex align-items-start">
              <div class="pic"><img :src="doctor.image" class="img-fluid" alt=""></div>
              <div class="member-info">
                <h4>{{doctor.name}}</h4>
                <span>{{doctor.designation}}</span>
                <p>{{doctor.gender}}</p>
                <div class="social">
                  <a href=""><i class="ri-twitter-fill"></i></a>
                  <a href=""><i class="ri-facebook-fill"></i></a>
                  <a href=""><i class="ri-instagram-fill"></i></a>
                  <a href=""> <i class="ri-linkedin-box-fill"></i> </a>
                  <div style="padding: 10px;">
                    <b-button :variant="(doctor.status)? 'success' : 'danger'" class="ml-1" @click="setModal(doctor)">Call</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!--pagination          -->
          <b-pagination

          >

          </b-pagination>

        </div>
      </div>
    </section>

    <b-modal ref="my-modal" centered title="Ekhoni Doctor">
      <div class="d-block text-center">
        <h3>{{selected_doctor}}</h3>
      </div>
      <b-form>

        <b-form-group id="patient_name_group" label="Enter The Name Of Patient:" label-for="patient_name"
                      description="Select Patient From Your Patient List">
          <b-form-select id="patient_name" required v-model="selected_patient_name" :options="options"></b-form-select>
        </b-form-group>

        <b-row>
          <b-col>
            <div>
              <b-form-group id="date_group" label="Date" label-for="date" description="Select date of appiontment">
                <div id="date">
                  <b-form-select id="date" required v-model="selected_date" :options="dates"></b-form-select>
                </div>
              </b-form-group>
            </div>
          </b-col>
          <b-col>
            <b-form-group id="time_group" label="End Time :" label-for="time" description="Select time of appiontment">
              <div v-show="selected_date!==null">
                <div v-if="times.length!==0">
                  <b-form-select id="time" required v-model="selected_time" :options="times"></b-form-select>
                </div>
                <h4 v-else>No time on this date</h4>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <template v-slot:modal-footer>
        <b-button size="sm" variant="success">
          Confirm
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel">
          Cancel
        </b-button>

      </template>
    </b-modal>

  </div>
</template>

<script>
import FetchDoctorService from "@/services/general_user/fetch_doctor.service";

export default {
  name: "DoctorsList",
  data() {
    return {
      activeDoctor: [],
      doctorCategory: '',
      selected_patient_name: null,
      selected_date: null,
      selected_time: null,
      selected_doctor: null,
      options: [
        // { value: null, text: 'Please select an option' },
        {value: null, text: 'Please Select Patient\'s Name', disabled: true},
        'NAFIS FUAD' , 'RADOWAN MAHMUD REDOY' , 'AHMED RYAN'
      ],
      times:['7.30 pm', '7.30 pm', '7.30 pm'],
      dates:[{value: null, text: 'Please Select Date', disabled: true},'14-8-2020','15-8-2020','16-8-2020']
    };
  },
  methods:{
    setModal(doctor){
      if(doctor.status){
        this.$refs['my-modal'].show();
        this.selected_doctor=doctor.name;
      }
    },
    confirm(){

    },
    cancel(){
      this.selected_patient_name=null;
      this.selected_date=null;
      this.selected_time=null;
      this.selected_doctor=null
      this.$refs['my-modal'].hide();
    },
    fetchActiveDoctors() {
      FetchDoctorService.fetchActiveDoctor().then( response => {
        if(response.status == 200) {
          this.activeDoctor = response.data.data;
          console.log(response);
          alert("Doctors fetched successfully!");
        }
        else{
          alert("Doctors could not be fetched!");
        }
      })
    }
  },
  mounted() {
    this.fetchActiveDoctors();
  }
}
</script>

<style scoped>
.col-description{
  font-weight: bold;
  font-family: sans-serif;
  font-size: 16px;
  color: #1A86D0;
  margin-left: 4%;
  margin-top: 1%;
}
.dropdownitem{
  padding: 3px;
}

</style>